import React from 'react';
import { LuScanFace } from 'react-icons/lu';

// Capture button states (design-recreation CREATE):
//   idle     gradient aurum-faint bg, #C9A45C border, aurum-bright text
//   scanning same chrome, disabled, "SCANNING…"
//   done     metallic gradient, ink text, "CAPTURE NEW SCAN" (resets)
const LABELS = {
  idle: 'CAPTURE SCAN',
  scanning: 'SCANNING…',
  done: 'CAPTURE NEW SCAN',
};

const CaptureButton = ({ state = 'idle', onClick, className = '' }) => {
  const done = state === 'done';
  const scanning = state === 'scanning';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={scanning}
      className={[
        'w-full h-[54px] lg:h-[58px] rounded-field flex items-center justify-center gap-3',
        'font-display uppercase text-[13px] lg:text-sm font-semibold tracking-[0.22em] lg:tracking-[0.24em]',
        'transition-colors duration-200 ease-mogged border',
        done
          ? 'bg-metallic border-[#F0ECE2] text-[#1A1A1A] cursor-pointer'
          : 'bg-aurum-faint border-aurum text-aurum-bright',
        scanning ? 'opacity-80 cursor-default' : 'cursor-pointer',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <LuScanFace size={18} strokeWidth={1.6} aria-hidden="true" />
      <span>{LABELS[state] || LABELS.idle}</span>
    </button>
  );
};

export default CaptureButton;
